import { Session } from "@paywithglide/glide-js";

export function requiredPaymentAmount(session: Session): string | undefined {
  return session.requiredPaymentAmount || session.paymentAmount;
}
